import { Link } from 'react-router-dom';
import { ThemeButton } from './ThemeWrapper';

export default function CreationRequestNotifiersPanel({
  staff,
  selectedCount,
  busyId,
  loading,
  error,
  onToggle,
}) {
  return (
    <div className="space-y-4">
      <p className="text-sm theme-text-secondary">
        When the VE team submits the internal onboarding form, these people get an email and in-app
        notice. If nobody is selected, all active admins are notified. Grant{' '}
        <strong>Review VE onboarding / account requests</strong> on an access level if they should
        approve as well.
      </p>
      <div className="flex flex-wrap items-center gap-3">
        <span className="text-sm theme-text">{selectedCount} selected</span>
        <Link to="/admin/creation-requests">
          <ThemeButton type="button">Open account requests</ThemeButton>
        </Link>
      </div>
      {error && (
        <div
          className="p-3 rounded-lg text-sm"
          style={{ backgroundColor: 'var(--color-error-100)', color: 'var(--color-error)' }}
        >
          {error}
        </div>
      )}
      {loading ? (
        <p className="text-sm theme-text-secondary">Loading staff…</p>
      ) : staff.length === 0 ? (
        <p className="text-sm theme-text-secondary">No staff users to notify.</p>
      ) : (
        <ul className="space-y-2">
          {staff.map((u) => (
            <li
              key={u.id}
              className="p-3 rounded-lg border flex flex-wrap items-center gap-3"
              style={{ borderColor: 'var(--color-border)' }}
            >
              <label className="flex items-center gap-2 min-w-[220px] flex-1 theme-text cursor-pointer">
                <input
                  type="checkbox"
                  checked={Boolean(u.notified)}
                  disabled={busyId === u.id}
                  onChange={(e) => onToggle(u.id, e.target.checked)}
                />
                <span>
                  <span className="font-medium">
                    {u.firstName} {u.lastName}
                  </span>
                  <span className="block text-xs theme-text-secondary">{u.email}</span>
                </span>
              </label>
              <span className="text-xs theme-text-secondary">{u.role}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
